/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';
import { PropsWithChildren, useState, MouseEvent } from 'react';

type Props = {
  content: JSX.Element;
};

const ClickPopover = ({ children, content }: PropsWithChildren<Props>) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
        {children}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {content}
      </Popover>
    </>
  );
};

export default ClickPopover;
